/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from 'react';
import {
  DragDropProvider,
  Grid,
  Table,
  TableColumnResizing,
  TableEditColumn,
  TableHeaderRow,
} from '@devexpress/dx-react-grid-material-ui';
import { Box, fade, Paper, Typography, withStyles } from '@material-ui/core';
import { DataTypeProvider, EditingState } from '@devexpress/dx-react-grid';
import { accountFormatter, currencyFormatter } from './colorFormat';
import { CommandSmall } from './CommandSmall';
import { getColumns } from '../common/columns';
import { useTemplate } from '../hooks';
import PopupEditing from './PopupEditing';
import PopupKaidItem from '../pubups/PopupKaidItem';

export const getRowId = (row: any) => row.index;

const NumberTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={({ value }) => (
      <Typography variant="subtitle2">{Number(value) + 1}</Typography>
    )}
    {...props}
  />
);

const styles = (theme) => ({
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade(theme.palette.primary.main, 0.1),
    },
  },
});

const TableComponentBase = ({ classes, ...restProps }) => (
  <Table.Table {...restProps} className={classes.tableStriped} />
);

export const TableComponent = withStyles(styles, { name: 'TableComponent' })(
  TableComponentBase
);

export default function KaidsSingleTable({
  rows,
  removeItem,
  isRTL,
  words,
  accounts,
  editItem,
  user,
  departments,
  employees,
  resourses,
  contracts,
  customers,
  suppliers,
}: any) {
  const col = getColumns({ isRTL, words });

  const { tempoptions } = useTemplate();
  const [columns] = useState(
    [
      { name: 'index', title: words.no },
      { name: 'acc', title: words.account },
      { name: 'amountDebit', title: words.amountDebit },
      { name: 'amountCredit', title: words.amountCredit },
      { name: 'desc', title: words.description },
      col.customer,
      col.supplier,
      tempoptions?.contract && col.contract,
      tempoptions?.resourse && col.resourse,
      col.employee,
      { name: 'manualDocNo', title: isRTL ? 'رقم المستند' : 'Document No' },
      { name: 'manualRefNo', title: isRTL ? 'رقم المرجع' : 'Reference No' },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'index', width: 50 },
    { columnName: 'acc', width: 150 },
    { columnName: 'amountDebit', width: 120 },
    { columnName: 'amountCredit', width: 120 },
    { columnName: 'desc', width: 300 },
    { columnName: col.customer.name, width: 150 },
    { columnName: col.supplier.name, width: 150 },
    { columnName: col.contract.name, width: 150 },
    { columnName: col.resourse.name, width: 150 },
    { columnName: col.employee.name, width: 150 },
    { columnName: 'manualDocNo', width: 120 },
    { columnName: 'manualRefNo', width: 120 },
  ]);

  const commitChanges = async ({ deleted }) => {
    if (deleted) {
      const index = deleted[0];
      removeItem(index);
    }
  };

  const renderEmpty = () => {
    return <Box display="flex"></Box>;
  };
  return (
    <Paper
      style={{
        maxHeight: 265,
        overflow: 'auto',
        margin: 10,
        minHeight: 265,
      }}
    >
      {rows && (
        <Grid rows={rows} columns={columns} getRowId={getRowId}>
          <EditingState onCommitChanges={commitChanges} />
          <DragDropProvider />
          <Table
            noDataCellComponent={renderEmpty}
            columnExtensions={tableColumnExtensions}
            tableComponent={TableComponent}
          />
          <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />
          <DataTypeProvider
            for={['amount', 'amountDebit', 'amountCredit']}
            formatterComponent={currencyFormatter}
          ></DataTypeProvider>
          <NumberTypeProvider for={['index']} />
          <DataTypeProvider
            for={['acc']}
            formatterComponent={(props) =>
              accountFormatter(props, accounts, isRTL)
            }
          ></DataTypeProvider>
          <TableEditColumn
            showDeleteCommand
            showEditCommand
            commandComponent={CommandSmall}
          ></TableEditColumn>
          <PopupEditing editAction={editItem}>
            <PopupKaidItem
              isRTL={isRTL}
              words={words}
              accounts={accounts}
              departments={departments}
              employees={employees}
              resourses={resourses}
              contracts={contracts}
              customers={customers}
              suppliers={suppliers}
              acustomer={true}
              asupplier={true}
              acontract={true}
              aresourse={true}
              aemployee={true}
              adepartment={true}
              user={user}
            ></PopupKaidItem>
          </PopupEditing>
          <TableHeaderRow
            titleComponent={({ children }) => {
              return (
                <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                  {children}
                </Typography>
              );
            }}
          />
        </Grid>
      )}
    </Paper>
  );
}
